import { render, staticRenderFns } from "./mis_gdp.vue?vue&type=template&id=ecc67ec6&scoped=true"
import script from "./mis_gdp.vue?vue&type=script&lang=js"
export * from "./mis_gdp.vue?vue&type=script&lang=js"
import style0 from "./mis_gdp.vue?vue&type=style&index=0&id=ecc67ec6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc67ec6",
  null
  
)

export default component.exports